import React from 'react'

import Card from '../../../components/layout/Card'
import type { Author } from '../../../../api/authors/types'
import { useI18N } from '../../../../libraries/i18n/hook'
import Slider from '../../../components/slider'

type Props = { authors: Author[] }
const AuthorsCarousel: React.FC<Props> = ({ authors }) => {
  const { t } = useI18N()
  return (
    <Card fullHeight={false} className='bg-white w-full text-center'>
      <h3 className='text-black'>{t('course.authors.title')}</h3>
      <Slider slides2xl={1} slidesXl={1} slidesLg={1} slidesMd={1} slidesSm={1} slidesXs={1}>
        {authors.map((author) => (
          <div key={author.displayName} className='inline-flex flex-wrap flex-col gap-y-4 items-center'>
            <img src={author.imageSrc} alt={author.displayName} className='w-24 h-24 rounded-full' />
            <h4 className='m-0 p-0 h-5 text-deep-green'>{author.name}</h4>
            <span className='text-xs sm:text-sm text-gray'>{author.role} - {author.companyName}</span>
            <p className='text-xs max-w-[650px] md:text-sm px-1 sm:px-12'>{author.description}</p>
          </div>
        ))}
      </Slider>
    </Card>
  )
}

export default AuthorsCarousel
